"use client";

import {
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from "react";

import type { InboxSidebarSelection } from "./module-inbox-data";

type InboxUiContextValue = {
  readonly inVorgangDetail: boolean;
  readonly setInVorgangDetail: Dispatch<SetStateAction<boolean>>;
  readonly inboxSelection: InboxSidebarSelection;
  readonly setInboxSelection: Dispatch<SetStateAction<InboxSidebarSelection>>;
};

const DEFAULT_INBOX_SELECTION: InboxSidebarSelection = { kind: "all" };

const InboxUiContext = createContext<InboxUiContextValue | null>(null);

export function InboxUiProvider(props: {
  readonly children: ReactNode;
}): ReactNode {
  const [inVorgangDetail, setInVorgangDetail] = useState<boolean>(false);
  const [inboxSelection, setInboxSelection] = useState<InboxSidebarSelection>(
    DEFAULT_INBOX_SELECTION,
  );

  const value: InboxUiContextValue = useMemo(
    (): InboxUiContextValue => ({
      inVorgangDetail,
      setInVorgangDetail,
      inboxSelection,
      setInboxSelection,
    }),
    [inVorgangDetail, inboxSelection],
  );

  return (
    <InboxUiContext.Provider value={value}>
      {props.children}
    </InboxUiContext.Provider>
  );
}

export function useInboxUi(): InboxUiContextValue {
  const context: InboxUiContextValue | null = useContext(InboxUiContext);
  if (context === null) {
    return {
      inVorgangDetail: false,
      setInVorgangDetail: () => undefined,
      inboxSelection: DEFAULT_INBOX_SELECTION,
      setInboxSelection: () => undefined,
    };
  }
  return context;
}
